/**
 * lib/viewportStore.js — single-source-of-truth for cross-route viewport
 * preservation.
 *
 * Why: the user wants "return to last location" when navigating back from
 * /sheet/{id}/compare to /sheet/{id}. The SheetCanvas already persists per-
 * sheet viewports in localStorage with key `fop_vp_{sheetId}`, but that's
 * scoped to its own component lifecycle — components that need to
 * coordinate viewport state across routes (compare → viewer, plan-wall →
 * viewer, etc.) need a stable API.
 *
 * Storage: localStorage. Single-tab semantics are fine; supers don't open
 * the same sheet in 3 tabs.
 */

const KEY_PREFIX = "fop_vp_";

export function readViewport(sheetId) {
  if (!sheetId) return null;
  try {
    const raw = localStorage.getItem(KEY_PREFIX + sheetId);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeViewport(sheetId, vp) {
  if (!sheetId || !vp) return;
  try {
    localStorage.setItem(KEY_PREFIX + sheetId, JSON.stringify(vp));
  } catch { /* quota exceeded — silently drop */ }
}

export function clearViewport(sheetId) {
  if (!sheetId) return;
  try { localStorage.removeItem(KEY_PREFIX + sheetId); } catch {}
}
